<template lang="pug">

.app-card.overflow-x-auto.technicians-styled-panel
  //- Header con título e ícono
  .d-flex.align-items-center.justify-content-between.tw-mb-3.tw-pb-2.tw-border-b.tw-border-gray-200
    .d-flex.align-items-center.tw-gap-2
      i.fa-solid.fa-users-gear.tw-text-blue-600
      span.tw-font-semibold.tw-text-gray-700 Technicians
      span.tw-bg-blue-100.tw-text-blue-700.tw-px-2.tw-py-1.tw-rounded-full.tw-text-xs.tw-font-medium
        | {{ all_technicians.length }}
    add-technician-to-order-modal(
      :data-icon='"fa-solid fa-plus"'
      :data-label="$I18n.t('vue.technicians_detail_panel.add_technician')"
      :data-mode='"new"'
      :data-item='JSON.stringify(empty_item)'
      :data-id='record.id' 
      :data-model='record.model'
      :data-technicians-active='technicians_to_options()'
      @add='addTechnician'
    )
  
  //- Tabla mejorada
  table(v-if='!emptyItems' class="table table-hover technicians-styled-table")
    thead.tw-bg-gray-50
      tr
        th.tw-text-left
          .d-flex.align-items-center.tw-gap-1
            i.fa-solid.fa-user.tw-text-gray-400.tw-text-xs
            span {{$I18n.t('vue.technicians_detail_panel.table_header_name')}}
        th.tw-text-left
          .d-flex.align-items-center.tw-gap-1
            i.fa-solid.fa-id-badge.tw-text-gray-400.tw-text-xs
            span {{$I18n.t('vue.technicians_detail_panel.table_header_role_name')}}
        th.tw-text-left
          .d-flex.align-items-center.tw-gap-1
            i.fa-solid.fa-envelope.tw-text-gray-400.tw-text-xs
            span {{$I18n.t('vue.technicians_detail_panel.table_header_email')}}
        th.tw-text-left
          .d-flex.align-items-center.tw-gap-1
            i.fa-solid.fa-phone.tw-text-gray-400.tw-text-xs
            span {{$I18n.t('vue.technicians_detail_panel.table_header_phone')}}
        th.tw-text-center.tw-w-20 Actions
    tbody
      tr(v-for="item in all_technicians" :key="item.id" class="tw-transition-colors hover:tw-bg-blue-50")
        td
          .d-flex.align-items-center.tw-gap-2
            //- Avatar con iniciales
            .tw-w-8.tw-h-8.tw-rounded-full.tw-bg-blue-100.tw-flex.tw-items-center.tw-justify-center.tw-flex-shrink-0
              span.tw-text-blue-600.tw-text-xs.tw-font-semibold {{ getInitials(item.technician.table.full_name) }}
            span.tw-font-medium.tw-text-gray-800 {{item.technician.table.full_name}}
        td
          span.tw-inline-flex.tw-items-center.tw-px-2.tw-py-1.tw-rounded.tw-text-xs.tw-font-medium(:class="getRoleBadgeClass(item.technician.table.role_name)")
            | {{item.technician.table.role_name}}
        td
          a.tw-text-blue-600.tw-text-sm(v-if="item.technician.table.email" :href="'mailto:' + item.technician.table.email")
            i.fa-solid.fa-envelope.tw-mr-1.tw-text-xs
            | {{item.technician.table.email}}
          span.tw-text-gray-400.tw-text-sm(v-else) —
        td
          .d-flex.align-items-center.tw-gap-1(v-if="item.technician.table.phones[0] && item.technician.table.phones[0].table.number")
            span.tw-text-gray-500.tw-text-xs(v-if="item.technician.table.phones[0].table.kind")
              | {{ item.technician.table.phones[0].table.kind }}:
            a.tw-text-gray-700.tw-text-sm(:href="'tel:' + item.technician.table.phones[0].table.number")
              | {{item.technician.table.phones[0].table.number}}
          span.tw-text-gray-400.tw-text-sm(v-else) —
        td.tw-text-center
          .app-buttons-row.justify-content-center
            remove-technician-to-order-modal(
              :data-id='item.id'
              @deleted='retrieveTechnicians'
            )
  
  //- Estado vacío mejorado
  .tw-text-center.tw-py-8(v-if='emptyItems')
    .tw-w-16.tw-h-16.tw-bg-blue-100.tw-rounded-full.tw-flex.tw-items-center.tw-justify-center.tw-mx-auto.tw-mb-3
      i.fa-solid.fa-users.tw-text-blue-400.tw-text-2xl
    p.tw-text-gray-500.tw-mb-0 {{$I18n.t('vue.technicians_detail_panel.empty_items')}}

</template>
<script>

import RemoveTechnicianToOrderModal from './remove-technician-to-order-modal.vue'
import AddTechnicianToOrderModal from './add-technician-to-order-modal.vue'
import {BackendService} from '../../services';
import StickyTableMixin from '../../mixins/sticky_table_mixin.js';

export default {
  mixins: [StickyTableMixin],
  components:{
    'remove-technician-to-order-modal':RemoveTechnicianToOrderModal,
    'add-technician-to-order-modal':AddTechnicianToOrderModal
  },
  props:{
    dataId: String,
    dataModel: String,
    dataOrder: String,
    dataItems: String,
    dataTechniciansActive: String,
    dataOtherOrders: String,
  },
  data: function(){
    return {
      state: {
        confirmed: false,
      },
      record:{
        id: this.dataId,
        model: this.dataModel
      },
      items: JSON.parse(this.dataItems),
      other_orders: JSON.parse(this.dataOtherOrders),
      data_order: JSON.parse(this.dataOrder),
      empty_item: {
        person:{
          first_name:"",
          middle_name:"",
          last_name:"",
        },
        role_name:"",
        email:"",
        state:"",
      }
    }
  },
  computed:{
    all_technicians: function(){
      var items = []
      if (this.other_orders.length != 0 && this.data_order.state.name != 'CANCELED'){
        this.other_orders.forEach(order => {
          if(order.state.name != "CANCELED"){
            order.technicians.forEach(t => {
              if(t.deleted_at === null){
                items.push(t)
              }
            })
          }
        })
      }else{
        items = this.items
      }
      return items
    },
    emptyItems: function(){
      return this.all_technicians.length === 0;
    }
  },
  methods:{
    getInitials: function(name) {
      if (!name) return '?';
      const parts = name.split(' ').filter(p => p.length > 0);
      if (parts.length >= 2) {
        return (parts[0][0] + parts[parts.length-1][0]).toUpperCase();
      }
      return name.substring(0, 2).toUpperCase();
    },
    getRoleBadgeClass: function(role) {
      const roleMap = {
        'Lead': 'tw-bg-purple-100 tw-text-purple-700',
        'Technician': 'tw-bg-blue-100 tw-text-blue-700',
        'Helper': 'tw-bg-gray-100 tw-text-gray-700',
        'Supervisor': 'tw-bg-amber-100 tw-text-amber-700',
      };
      return roleMap[role] || 'tw-bg-gray-100 tw-text-gray-700';
    },
    showTechnician:function(path){
    },
    retrieveTechnicians:function(){
      let self = this; 
      BackendService
        .technicians(JSON.stringify({
          query:{
            technicianable_type: self.record.model,
            technicianable_id: self.record.id
          }
        }))
        .then((response)=>{
          self.result = response;
          if (response.isOk){
            self.items = response.technicians;
          }
        })
        .finally(()=>{
        })
    },
    addTechnician:function(params){
      const self = this;
      this.state.sending = true;
      BackendService
        .add_technician_to_order(params)
        .then((response)=>{
          self.result = response;
          if (response.isOk){
            location.reload();
          }
        })
        .catch(()=>{
          self.result.isError=true;
          self.result.notice='error_promise';
          self.state.sending = false;
        })
        .finally(()=>{
        })
      
    },
    technicians_to_options:function(){
      let technicians = JSON.parse(this.dataTechniciansActive)
      let items = this.all_technicians
      var array_technicians_for_options = []
      technicians.forEach(function(technician){
        let technician_exist = false
        items.forEach(function(item){
          let item_name = item.technician.table.full_name
          let technician_name = technician.label
          if (item_name == technician_name){
            technician_exist = true
          }
        })
        if (technician_exist==false){
          array_technicians_for_options.push(technician)
        }
      })
      return JSON.stringify(array_technicians_for_options)
    }
  }
}
</script>

<style scoped>
.technicians-styled-panel {
  padding: 1rem;
}

.technicians-styled-table {
  font-size: 0.85rem;
}

.technicians-styled-table thead th {
  white-space: nowrap;
  vertical-align: middle;
  padding: 0.5rem 0.75rem;
  font-weight: 600;
  color: #4b5563;
}

.technicians-styled-table tbody td {
  vertical-align: middle;
  padding: 0.5rem 0.6rem;
}
</style>
